import { configureStore } from '@reduxjs/toolkit';
import settingReducer from './setting/reducers';
import holidayReducer from './holiday/holidaySlice';
import medicationReducer from './medication/medicationSlice';
import dailyReportReducer from './dailyReport/dailyReportSlice';
import menuChartReducer from './menuChart/menuChartSlice';
import accidentReportReducer from './accidentReport/accidentReportSlice';
import illnessReportReducer from './illnessReport/illnessReportSlice';
import allergyActionPlanReducer from './allergyActionPlan/allergyActionPlanSlice';
import lunchPlanWaiverReducer from './lunchPlanWaiver/lunchPlanWaiverSlice';
import noPeanutPolicyReducer from './noPeanutPolicy/noPeanutPolicySlice';
import emergencyContactReducer from './emergencyContact/emergencyContactSlice';

export const store = configureStore({
  reducer: {
    setting: settingReducer,
    holiday: holidayReducer,
    medication: medicationReducer,
    dailyReport: dailyReportReducer,
    menuChart: menuChartReducer,
    accidentReport: accidentReportReducer,
    illnessReport: illnessReportReducer,
    allergyActionPlan: allergyActionPlanReducer,
    lunchPlanWaiver: lunchPlanWaiverReducer,
    noPeanutPolicy: noPeanutPolicyReducer,
    emergencyContact: emergencyContactReducer
  }
});
